import type { PortraitAdjustment } from './portrait-stage.js';
/** Allen's September 12 field corrections: these asymmetric hairstyles pull the crop left. */
export const PORTRAIT_ADJUSTMENTS: Readonly<Record<string,PortraitAdjustment>> = {
  "allison": { "zoom": 1.12, "centerOnHead": true, "up": 0.04 },
  "arctax": { "zoom": 1.12, "centerOnHead": true, "up": 0.04 },
  "schiriba": { "zoom": 1.12, "centerOnHead": true, "up": 0.04 },
  "seeza": { "zoom": 1.12, "centerOnHead": true, "up": 0.04 }
};
